import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmployeeSelector = ({ selectedEmployees, onEmployeeChange, onSelectAll, onClearAll }) => {
  const [isOpen, setIsOpen] = useState(false);

  const employees = [
    {
      id: 1,
      name: 'مریم احمدی',
      role: 'آرایشگر ارشد',
      avatar: 'https://randomuser.me/api/portraits/women/1.jpg',
      services: ['کوتاهی مو', 'رنگ مو', 'هایلایت'],
      isActive: true
    },
    {
      id: 2,
      name: 'فاطمه رضایی',
      role: 'متخصص پوست',
      avatar: 'https://randomuser.me/api/portraits/women/2.jpg',
      services: ['پاکسازی پوست', 'ماساژ صورت'],
      isActive: true
    },
    {
      id: 3,
      name: 'زهرا محمدی',
      role: 'متخصص ناخن',
      avatar: 'https://randomuser.me/api/portraits/women/3.jpg',
      services: ['مانیکور', 'پدیکور', 'طراحی ناخن'],
      isActive: true
    },
    {
      id: 4,
      name: 'سارا کریمی',
      role: 'آرایشگر',
      avatar: 'https://randomuser.me/api/portraits/women/4.jpg',
      services: ['کوتاهی مو', 'فن مو'],
      isActive: false
    },
    {
      id: 5,
      name: 'نرگس حسینی',
      role: 'متخصص ابرو',
      avatar: 'https://randomuser.me/api/portraits/women/5.jpg',
      services: ['اصلاح ابرو', 'کاشت مژه'],
      isActive: true
    }
  ];

  const activeEmployees = employees?.filter(emp => emp?.isActive);
  const selectedCount = selectedEmployees?.length;
  const totalCount = activeEmployees?.length;

  const handleEmployeeToggle = (employeeId) => {
    const isSelected = selectedEmployees?.includes(employeeId);
    if (isSelected) {
      onEmployeeChange(selectedEmployees?.filter(id => id !== employeeId));
    } else {
      onEmployeeChange([...selectedEmployees, employeeId]);
    }
  };

  const getSelectedEmployeeNames = () => {
    if (selectedCount === 0) return 'انتخاب کارمند';
    if (selectedCount === totalCount) return 'همه کارمندان';
    if (selectedCount === 1) {
      const employee = activeEmployees?.find(emp => selectedEmployees?.includes(emp?.id));
      return employee?.name || 'کارمند انتخاب شده';
    }
    return `${selectedCount} کارمند انتخاب شده`;
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full lg:w-auto min-w-[250px] justify-between"
      >
        <div className="flex items-center gap-2">
          <Icon name="Users" size={16} />
          <span>{getSelectedEmployeeNames()}</span>
          {selectedCount > 0 && (
            <span className="bg-primary text-primary-foreground text-xs px-2 py-0.5 rounded-full">
              {selectedCount}
            </span>
          )}
        </div>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className={`transition-transform duration-150 ${isOpen ? 'rotate-180' : ''}`}
        />
      </Button>
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-popover border border-border rounded-lg shadow-elevation-3 z-dropdown animate-fade-in">
          <div className="p-3 border-b border-border">
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-medium text-foreground">انتخاب کارمندان</span>
              <div className="flex gap-1">
                <Button
                  variant="ghost"
                  size="xs"
                  onClick={() => {
                    onSelectAll();
                    setIsOpen(false);
                  }}
                  disabled={selectedCount === totalCount}
                >
                  همه
                </Button>
                <Button
                  variant="ghost"
                  size="xs"
                  onClick={() => {
                    onClearAll();
                    setIsOpen(false);
                  }}
                  disabled={selectedCount === 0}
                >
                  هیچکدام
                </Button>
              </div>
            </div>
          </div>

          <div className="max-h-64 overflow-y-auto">
            {activeEmployees?.map((employee) => {
              const isSelected = selectedEmployees?.includes(employee?.id);
              
              return (
                <button
                  key={employee?.id}
                  onClick={() => handleEmployeeToggle(employee?.id)}
                  className={`
                    w-full p-3 text-right hover:bg-muted transition-colors duration-150 border-b border-border last:border-b-0
                    ${isSelected ? 'bg-primary/10' : ''}
                  `}
                >
                  <div className="flex items-center gap-3">
                    <div className="relative">
                      <img
                        src={employee?.avatar}
                        alt={employee?.name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      {isSelected && (
                        <div className="absolute -top-1 -right-1 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                          <Icon name="Check" size={12} color="white" />
                        </div>
                      )}
                    </div>
                    
                    <div className="flex-1 text-right">
                      <h4 className="text-sm font-medium text-foreground">
                        {employee?.name}
                      </h4>
                      <p className="text-xs text-muted-foreground">
                        {employee?.role}
                      </p>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {employee?.services?.slice(0, 2)?.map((service, index) => (
                          <span
                            key={index}
                            className="text-xs bg-muted text-muted-foreground px-2 py-0.5 rounded"
                          >
                            {service}
                          </span>
                        ))}
                        {employee?.services?.length > 2 && (
                          <span className="text-xs text-muted-foreground">
                            +{employee?.services?.length - 2}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-[250]" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default EmployeeSelector;